import "core-js/modules/es.string.link.js";
import { defineComponent } from 'vue';
export default defineComponent({
  name: 'ImageInfomation',
  props: {
    image: {
      type: String,
      defaultValue: ''
    },
    link: {
      type: String
    },
    title: {
      type: String,
      defaultValue: ''
    },
    desc: {
      type: String,
      defaultValue: ''
    }
  },
  setup: function setup(props) {
    var onClickItem = function onClickItem() {
      if (props.link) {
        window.location.href = props.link;
      }
    };

    return {
      onClickItem: onClickItem
    };
  }
});